export default function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link(scope, element, attr, ngModelCtrl) {
      const pattern = /[^a-zA-Z 0-9]+/g;

      function onInput(text) {
        if (!text) {
          return text;
        }
        const replacedText = text.replace(pattern, '');
        if (replacedText !== text) {
          ngModelCtrl.$setViewValue(replacedText);
          ngModelCtrl.$render();
        }
        return replacedText;
      }

      ngModelCtrl.$parsers.push(onInput);
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/strip-special-characters/strip-special-characters.directive.js